import type { Experiment, Result, TrackingCallback } from '@growthbook/growthbook';

import { isClient } from '../utils/isClient';
import { dispatchTrackingEventGA4 } from './dispatchTrackingEventGA4';

const trackedExperiments = new Set<string>();

export const growthbookTrackingCallback: TrackingCallback = (
  experiment: Experiment<any>,
  result: Result<any>
) => {
  if (!isClient()) return;

  const trackingKey = `${experiment.key}:${experiment.phase}:${result.key}`;

  if (!trackedExperiments.has(trackingKey)) {
    trackedExperiments.add(trackingKey);

    dispatchTrackingEventGA4({
      event: 'experience_impression',
      exp_variant_string: trackingKey,
    });
  }
};
